import { API_URL, ADVERTISER_API_TOKEN } from '../../config';
import { applyPreproductionSettings } from '../../utils/PreproductionSettings';

const fetchWithAuth = async (url: string, lang: string) => {
  url = applyPreproductionSettings(url);
  if (lang.includes('zh')) {
    url += url.includes('?') ? '&locale=zh-Hant-HK&fallbackLocale=false' : '?locale=zh-Hant-HK&fallbackLocale=false';
  }
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${ADVERTISER_API_TOKEN}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const fetchAdvertiser = async (lang: string) => {
  try {
    const advertiserResponse = await fetchWithAuth(
      `${API_URL}/advertiser?populate=Banner.DesktopBannerImage,Banner.TabletBannerImage,Banner.MobileBannerImage,Banner.BannerButtonLink,ColumnedContent.ButtonLink,ColumnedContent.ContentImage,ColumnedContent.SecondLink,FormLabels,AdvertisementChannels.channels.icon,GA,SEO.MetaImage&pagination[limit]=-1`,
      lang
    );

    const advertiser = advertiserResponse.data;

    console.log('fetchAdvertiser API Response:', advertiser);
    return advertiser;
  } catch (error) {
    console.error('Error fetching packs.', error);
    return null;
  }
};